import { COUNTRIES } from '../constants/countries';

export interface Country {
    langCode: string;
    code: string;
    name: string;
    flag: string;
}

/**
 * Detects the default country based on the provided locale
 * @param locale - The locale string to match against country language codes
 * @returns The matching country object or the first country (US) as fallback
 */
export function detectDefaultCountry(locale: string): Country {
    // Normalize locale to lowercase for case-insensitive comparison
    const normalizedLocale = locale.toLowerCase();

    // Try to find exact match first
    const exactMatch = COUNTRIES.find(country =>
        country.langCode.toLowerCase() === normalizedLocale
    );

    if (exactMatch) {
        return exactMatch;
    }

    // If no exact match, try to find partial match (e.g., 'en-US' should match 'en')
    const partialMatch = COUNTRIES.find(country =>
        normalizedLocale.startsWith(country.langCode.toLowerCase())
    );

    if (partialMatch) {
        return partialMatch;
    }

    // Fallback to US (first country in the list)
    return COUNTRIES[0];
}

/**
 * Gets all available countries
 * @returns Array of all countries
 */
export function getAllCountries(): Country[] {
    return COUNTRIES;
}

/**
 * Gets country by language code
 * @param langCode - The language code to search for
 * @returns The matching country or undefined if not found
 */
export function getCountryByLangCode(langCode: string): Country | undefined {
    return COUNTRIES.find(country =>
        country.langCode.toLowerCase() === langCode.toLowerCase()
    );
}
